module.exports = __webpack_public_path__ + "images/referenzen/werbespot/dominos_bella_biancas_tvc_small.jpg";